import dayjs from "dayjs";

const current = dayjs();

export const currentYear = current.year();
export const currentMonth = current.month() + 1;
export const currentDay = current.date();
